import * as Yup from 'yup';
import type { TFunction } from 'i18next';
import { emailValidator } from '@gokrew/ui/utility/validators';

// Sign-in only needs presence checks. Password length/complexity rules belong
// to password *creation* (reset / change password), not to login — enforcing
// them here would wrongly block valid existing credentials and leak the rules.
// Mirrors the frontend login schema: a valid email and a non-empty password.
export const loginSchema = (t: TFunction) =>
  Yup.object({
    email: emailValidator(t('validation.login.email_invalid')).required(
      t('validation.login.email_required')
    ),
    password: Yup.string().required(t('validation.login.password_required')),
  });
